import { Color3 } from "@babylonjs/core/Maths/math.color";
import { CameraControl, CameraModeMask } from '@egr/wcf/modules/core/view/CameraControl';
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
export class AdditionGeometry {
    constructor(pRoomManager, pAdditions) {
        this.mAddition = pAdditions;
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mMatManager = pRoomManager.app.model.materials;
    }
    get canMirrorH() {
        return (true);
    }
    get canMirrorV() {
        return (true);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 1;
        tParams.height = 1;
        tParams.floorOffset = 1;
        tParams.wallOffset = 0.05;
        tParams.color = "#ffffff";
        return (tParams);
    }
    create2dGeometry(pParent) {
        //
    }
    create3dGeometry(pParent) {
        //
    }
    getProperties() {
        return (null);
    }
    serializeIOData() {
        return (null);
    }
    loadIOData(pData) {
        //
    }
    getEOXDescription(pDocument, pParentNode, pRootNode, pWall) {
        //
    }
    getEOXDescription_objects(pDocument, pRootNode, pWall) {
        //
    }
    getWhitePlasticMaterial() {
        let tMat = this.mMatManager.getMaterial(AdditionGeometry.MAT_KEY_WHITEPLASTIC);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = Color3.White().toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0.2;
            this.mMatManager.addMaterial(AdditionGeometry.MAT_KEY_WHITEPLASTIC, tMat);
        }
        return (tMat);
    }
    prepare2dMesh(pMesh) {
        if (pMesh == null)
            return;
        CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.Top | CameraModeMask.Bottom);
        pMesh.freezeWorldMatrix();
    }
    prepare3dMesh(pMesh) {
        if (pMesh == null)
            return;
        pMesh.freezeWorldMatrix();
        //not visible in top and bottom view
        CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.All &
            ~CameraModeMask.Top & ~CameraModeMask.Bottom);
    }
}
